import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  ButtonGroup,
  Button,
  Snackbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  FormControlLabel,
  Checkbox,
  DialogContent,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import DatePicker from "react-datepicker";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SearchIcon from "@mui/icons-material/Search";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const UbahReturPembelian = () => {
  const screenSize = useScreenWidth();
  const { user, setting, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [openUbah, setOpenUbah] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isInputStok, setIsInputStok] = useState(false);

  // Data Retur Pembelian
  const [noNotaReturPembelian, setNoNotaReturPembelian] = useState("");
  const [tglReturPembelian, setTglReturPembelian] = useState(null);
  const [jumlahItem, setJumlahItem] = useState("0");

  // Data Supplier
  const [kodeSupplier, setKodeSupplier] = useState("");
  const [namaSupplier, setNamaSupplier] = useState("");
  const [alamatSupplier, setAlamatSupplier] = useState("");
  const [noNotaPembelian, setNoNotaPembelian] = useState("");
  const [kodeCOA, setKodeCOA] = useState("");
  const [keterangan, setKeterangan] = useState("");

  // Data Total
  const [subtotal, setSubtotal] = useState("0");
  const [potongan, setPotongan] = useState("0");
  const [isPpn, setIsPpn] = useState(false);
  const [total, setTotal] = useState("0");
  const [ppnPersen, setPpnPersen] = useState("0");
  const [ppnTotal, setPpnTotal] = useState("0");
  const [kembali, setKembali] = useState("0");

  // Data Retur Pembelian Kredit
  const [tipeReturPembelian, setTipeReturPembelian] = useState("TUNAI");

  // Data Retur Pembelian Child
  const [idReturPembelianChild, setIdReturPembelianChild] = useState("");
  const [pilihStok, setPilihStok] = useState("");
  const [kodeStok, setKodeStok] = useState("");
  const [namaStok, setNamaStok] = useState("");
  const [quantityLama, setQuantityLama] = useState("0");
  const [quantity, setQuantity] = useState("0");
  const [hargaSatuan, setHargaSatuan] = useState("0");
  const [discountPersen1, setDiscountPersen1] = useState("0");
  const [discount1, setDiscount1] = useState("0");
  const [hargaNetto, setHargaNetto] = useState("0");
  const [totalReturPembelianChild, setTotalReturPembelianChild] = useState("0");

  const [returPembelianChilds, setReturPembelianChilds] = useState([]);

  const [stoks, setStoks] = useState([]);
  const [searchTermStok, setSearchTermStok] = useState("");
  const [openStok, setOpenStok] = useState(false);

  let [pageStok, setPageStok] = useState(0);
  const [limitStok, setLimitStok] = useState(10);
  const [pagesStok, setPagesStok] = useState(0);
  const [rowsStok, setRowsStok] = useState(0);
  const [queryStok, setQueryStok] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleClickOpenUbah = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenUbah(true);
  };

  const handleCloseUbah = () => {
    setOpenUbah(false);
    setIdReturPembelianChild("");
    setKodeStok("");
    setNamaStok("");
    setQuantityLama("");
    setQuantity("");
    setHargaSatuan("");
    setDiscountPersen1("");
    setDiscount1("");
    setHargaNetto("");
    setTotalReturPembelianChild("");
  };

  const handleChangeStok = (e, p) => {
    setPageStok(p - 1);
  };

  const searchDataStok = (e) => {
    e.preventDefault();
    setPageStok(0);
    setSearchTermStok(queryStok);
  };

  const handleClickOpenStok = () => {
    setOpenStok(true);
  };

  const handleCloseStok = () => {
    setOpenStok(false);
  };

  const tipeReturPembelianOption = ["TUNAI", "KREDIT"];

  useEffect(() => {
    getReturPembelianById();
  }, []);

  useEffect(() => {
    getStoksData();
  }, [pageStok, searchTermStok]);

  const getReturPembelianById = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/returPembelians/${id}`, {
      kodeCabang: user.cabang.id,
      _id: user.id,
      token: user.token,
    });
    // Data Retur Pembelian
    setNoNotaReturPembelian(response.data.noNotaReturPembelian);
    setTglReturPembelian(new Date(response.data.tglReturPembelian));

    // Data Supplier
    setKodeSupplier(response.data.supplier.kodeSupplier);
    setNamaSupplier(response.data.supplier.namaSupplier);
    setAlamatSupplier(response.data.supplier.alamatSupplier);
    setNoNotaPembelian(
      response.data.pembelian ? response.data.pembelian.noNotaPembelian : "",
    );
    setKodeCOA(
      response.data.coa &&
        `${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`,
    );
    setKeterangan(response.data.keterangan);

    // Data Total
    setSubtotal(response.data.subtotal);
    setPotongan(response.data.potongan);
    setTotal(response.data.total);
    if (response.data.ppnPersen > 0) {
      setIsPpn(true);
    }
    setPpnPersen(response.data.ppnPersen);
    setPpnTotal(response.data.ppnTotal);
    setKembali(response.data.kembali);

    // Data Retur Pembelian Kredit
    setTipeReturPembelian(response.data.tipeReturPembelian);

    const response2 = await axios.post(
      `${tempUrl}/returPembelianChildsByReturPembelian`,
      {
        returPembelianId: response.data.id,
        kodeCabang: user.cabang.id,
        _id: user.id,
        token: user.token,
      },
    );
    setReturPembelianChilds(response2.data);
    setJumlahItem(response2.data.length);
    setLoading(false);
  };

  const getStoksData = async () => {
    const response = await axios.post(
      `${tempUrl}/stoksPagination?search_query=${searchTermStok}&page=${pageStok}&limit=${limitStok}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      },
    );
    setStoks(response.data.stoks);
    setPageStok(response.data.page);
    setPagesStok(response.data.totalPage);
    setRowsStok(response.data.totalRows);
  };

  const updateReturPembelian = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      try {
        setLoading(true);
        await axios.post(`${tempUrl}/updateReturPembelianTotal/${id}`, {
          tglReturPembelian,
          // Total
          subtotal,
          potongan,
          total,
          ppnTotal,
          kembali,

          // Data Retur Pembelian Kredit
          tipeReturPembelian,

          userIdUpdate: user.id,
          _id: user.id,
          token: user.token,
        });
        setLoading(false);
        navigate(`/daftarReturPembelian/returPembelian/${id}`);
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const getFindStok = async (input) => {
    const response = await axios.post(`${tempUrl}/findStok`, {
      input,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKodeStok(response.data.kodeStok);
    setNamaStok(response.data.namaStok);
  };

  const saveReturPembelianChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0 &&
      discountPersen1.length !== 0 &&
      discount1.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedReturPembelianChild = await axios.post(
          `${tempUrl}/saveReturPembelianChild`,
          {
            // Data Retur Pembelian Child
            returPembelianId: id,
            kodeStok,
            namaStok,
            quantity,
            hargaSatuan,
            discountPersen1,
            discount1,
            hargaNetto,
            totalReturPembelianChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          },
        );
        setIsInputStok(false);

        // Data Retur Pembelian Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setQuantityLama("");
        setQuantity("");
        setHargaSatuan("");
        setDiscountPersen1("");
        setDiscount1("");
        setHargaNetto("");
        setTotalReturPembelianChild("");

        let findReturPembelianChild = await axios.post(
          `${tempUrl}/returPembelianChildsByReturPembelian`,
          {
            returPembelianId: id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          },
        );
        setReturPembelianChilds(findReturPembelianChild.data);
        setJumlahItem(findReturPembelianChild.data.length);

        let findReturPembelian = await axios.post(
          `${tempUrl}/returPembelians/${id}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          },
        );
        setSubtotal(findReturPembelian.data.subtotal);
        let tempPotongan = 0;
        setPotongan(tempPotongan);
        let tempTotal =
          parseFloat(tempPotongan) +
          parseFloat(findReturPembelian.data.subtotal);
        setTotal(tempTotal);
        let tempKembali = parseFloat(ppnTotal) - parseFloat(tempTotal);
        setKembali(tempKembali);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const updateReturPembelianChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0 &&
      discountPersen1.length !== 0 &&
      discount1.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedReturPembelianChild = await axios.post(
          `${tempUrl}/updateReturPembelianChild/${idReturPembelianChild}`,
          {
            // Data Retur Pembelian Child
            returPembelianId: id,
            kodeStok,
            namaStok,
            quantityLama,
            quantity,
            hargaSatuan,
            discountPersen1,
            discount1,
            hargaNetto,
            totalReturPembelianChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          },
        );
        setIsInputStok(false);

        // Data Retur Pembelian Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setQuantityLama("");
        setQuantity("");
        setHargaSatuan("");
        setDiscountPersen1("");
        setDiscount1("");
        setHargaNetto("");
        setTotalReturPembelianChild("");

        let findReturPembelianChild = await axios.post(
          `${tempUrl}/returPembelianChildsByReturPembelian`,
          {
            returPembelianId: id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          },
        );
        setReturPembelianChilds(findReturPembelianChild.data);
        setJumlahItem(findReturPembelianChild.data.length);

        let findReturPembelian = await axios.post(
          `${tempUrl}/returPembelians/${id}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          },
        );
        setSubtotal(findReturPembelian.data.subtotal);
        setPotongan("0");
        setPpnPersen("0");
        setPpnTotal("0");
        setTotal(findReturPembelian.data.subtotal);

        handleCloseUbah();
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const deleteReturPembelianChild = async (
    e,
    returPembelianChildId,
    quantity,
    totalReturPembelianChild,
  ) => {
    e.preventDefault();
    e.stopPropagation();

    const confirmed = window.confirm("Yakin ingin menghapus barang ini?");
    if (!confirmed) return;

    const form = e.currentTarget;
    if (form.checkValidity()) {
      // setLoading(true);
      try {
        // setLoading(true);
        let deletedReturPembelianChild = await axios.post(
          `${tempUrl}/deleteReturPembelianChild/${returPembelianChildId}`,
          {
            // Data Retur Pembelian Child
            returPembelianId: id,
            quantity,
            totalReturPembelianChild,

            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          },
        );
        setIsInputStok(false);

        let findReturPembelianChild = await axios.post(
          `${tempUrl}/returPembelianChildsByReturPembelian`,
          {
            returPembelianId: id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          },
        );
        setReturPembelianChilds(findReturPembelianChild.data);
        setJumlahItem(findReturPembelianChild.data.length);

        let findReturPembelian = await axios.post(
          `${tempUrl}/returPembelians/${id}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          },
        );
        setSubtotal(findReturPembelian.data.subtotal);
        setPotongan("0");
        setPpnPersen("0");
        setPpnTotal("0");
        setTotal(findReturPembelian.data.subtotal);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Retur Pembelian</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      <Form noValidate validated={validated}>
        <Card>
          <Card.Header>Data Retur Pembelian</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Nota :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={noNotaReturPembelian}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          required
                          dateFormat="dd/MM/yyyy"
                          selected={tglReturPembelian}
                          minDate={new Date(user.tutupperiode.dariTanggal)}
                          maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglReturPembelian(date);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jumlah Item :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={jumlahItem}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Supplier</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Polisi :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={kodeSupplier} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={namaSupplier} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={alamatSupplier} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={tipeReturPembelian} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Nota :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={noNotaPembelian} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode Kas :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={kodeCOA} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Catatan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={keterangan} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="contained"
            color="info"
            sx={{
              bgcolor: "info.light",
              textTransform: "none",
              marginRight: 2,
              marginBottom: 2,
            }}
            // type="submit"
            onClick={() => {
              setIsInputStok(true);
              setQuantityLama("0");
              setQuantity("0");
              setHargaSatuan("0");
              setDiscountPersen1("0");
              setDiscount1("0");
              setHargaNetto("0");
              setTotalReturPembelianChild("0");
            }}
          >
            {"+ Input Transaksi"}
          </Button>
        </Box>
      </Form>

      <Form noValidate validated={validated} onSubmit={saveReturPembelianChild}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Transaksi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode / Barcode{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={pilihStok}
                          onChange={(e) => {
                            setPilihStok(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              // alert("Enter pressed on kodeStok");
                              getFindStok(e.target.value);
                            }
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenStok()}
                          disabled={isInputStok === true ? false : true}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Stok :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={namaStok} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Quantity{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={quantity}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            const tempValue = values.value;
                            setQuantity(tempValue);

                            let tempTotalReturPembelianChild =
                              parseFloat(tempValue) * parseFloat(hargaNetto);
                            setTotalReturPembelianChild(
                              tempTotalReturPembelianChild,
                            );
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Satuan{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={hargaSatuan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setHargaSatuan(tempValue);

                            let tempHargaNetto =
                              parseFloat(tempValue) - parseFloat(discount1);
                            setHargaNetto(tempHargaNetto);

                            let tempTotalReturPembelianChild =
                              parseFloat(quantity) * parseFloat(tempHargaNetto);
                            setTotalReturPembelianChild(
                              tempTotalReturPembelianChild,
                            );

                            let tempDiscount1 =
                              (parseFloat(tempValue) * discountPersen1) / 100;
                            setDiscount1(tempDiscount1);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc / Pot. 1{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;

                            let tempValue = values.formattedValue;
                            setDiscountPersen1(tempValue);

                            let tempDiscount1 =
                              (parseFloat(hargaSatuan) * tempValue) / 100;
                            setDiscount1(tempDiscount1);

                            let temHargaNetto =
                              parseFloat(hargaSatuan) -
                              parseFloat(tempDiscount1);
                            setHargaNetto(temHargaNetto);

                            let tempTotalReturPembelianChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalReturPembelianChild(
                              tempTotalReturPembelianChild,
                            );
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setDiscount1(tempValue);

                            let tempDiscountPersen1 =
                              (parseFloat(tempValue) /
                                parseFloat(hargaSatuan)) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen1 = Number(
                              tempDiscountPersen1.toFixed(2),
                            );
                            setDiscountPersen1(tempDiscountPersen1);

                            let temHargaNetto =
                              parseFloat(hargaSatuan) - parseFloat(tempValue);
                            setHargaNetto(temHargaNetto);

                            let tempTotalReturPembelianChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalReturPembelianChild(
                              tempTotalReturPembelianChild,
                            );
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Netto :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={hargaNetto}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={totalReturPembelianChild}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>

            <Box sx={spacingTop}>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
                disabled={isInputStok === true ? false : true}
              >
                Simpan Transaksi
              </Button>
            </Box>
          </Card.Body>
        </Card>
      </Form>

      <Box sx={tableChildWrapper}>
        <TableContainer component={Paper} sx={{ width: "100%" }}>
          <Table aria-label="simple table">
            <TableHead className={classes.root}>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Kode
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Nama Stok
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Qty.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Sat.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Harga
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  D1 (%)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Pot1 (Rp)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Total Rp.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Aksi
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {returPembelianChilds.map((user, index) => (
                <TableRow
                  key={user.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "&:hover": { bgcolor: Colors.grey300 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {user.stok.kodeStok}
                  </TableCell>
                  <TableCell>{user.stok.namaStok}</TableCell>
                  <TableCell align="right">
                    {user.quantity.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>{user.stok.satuanKecilStok}</TableCell>
                  <TableCell align="right">
                    {user.hargaNetto.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.discountPersen1.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.discount1.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.totalReturPembelianChild.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>
                    <ButtonGroup variant="contained">
                      <Button
                        sx={{ textTransform: "none" }}
                        onClick={(e) => {
                          handleClickOpenUbah(e);
                          setIdReturPembelianChild(user.id);
                          setKodeStok(user.stok.kodeStok);
                          setNamaStok(user.stok.namaStok);
                          setQuantityLama(user.quantity);
                          setQuantity(user.quantity);
                          setHargaSatuan(user.hargaSatuan);
                          setDiscountPersen1(user.discountPersen1);
                          setDiscount1(user.discount1);
                          setHargaNetto(user.hargaNetto);
                          setTotalReturPembelianChild(
                            user.totalReturPembelianChild,
                          );
                        }}
                      >
                        <EditIcon />
                      </Button>
                      <Button
                        color="error"
                        sx={{ textTransform: "none" }}
                        onClick={(e) => {
                          deleteReturPembelianChild(
                            e,
                            user.id,
                            user.quantity,
                            user.totalReturPembelianChild,
                          );
                        }}
                      >
                        <DeleteOutlineIcon />
                      </Button>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Form noValidate validated={validated} onSubmit={updateReturPembelian}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Total</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Subtotal :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={subtotal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Potongan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={potongan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setPotongan(tempValue);

                            let tempPpnTotal = 0;

                            if (isPpn) {
                              tempPpnTotal =
                                ((parseFloat(subtotal) -
                                  parseFloat(tempValue)) *
                                  parseFloat(ppnPersen)) /
                                100;
                              setPpnTotal(tempPpnTotal);
                            } else {
                              setPpnTotal(tempPpnTotal);
                            }

                            let tempTotal =
                              parseFloat(subtotal) -
                              parseFloat(tempValue) -
                              parseFloat(tempPpnTotal);
                            setTotal(tempTotal);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        PPN ({setting.ppnPersen}) <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="2">
                        <FormControlLabel
                          control={<Checkbox checked={isPpn} />}
                          onChange={() => {
                            setIsPpn(!isPpn);

                            if (!isPpn) {
                              setPpnPersen(setting.ppnPersen);
                              let tempPpnTotal =
                                ((parseFloat(subtotal) - parseFloat(potongan)) *
                                  parseFloat(setting.ppnPersen)) /
                                100;
                              setPpnTotal(tempPpnTotal);

                              let tempTotal =
                                parseFloat(subtotal) -
                                parseFloat(potongan) -
                                parseFloat(tempPpnTotal);
                              setTotal(tempTotal);
                            } else {
                              setPpnPersen(0);
                              setPpnTotal(0);

                              let tempTotal =
                                parseFloat(subtotal) - parseFloat(potongan);
                              setTotal(tempTotal);
                            }
                          }}
                        />
                      </Col>
                      <Col sm="5">
                        <NumericFormat
                          value={ppnTotal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={total}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarReturPembelian")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            type="submit"
            disabled={id === null && true}
          >
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={openStok}
        onClose={handleCloseStok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Stok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataStok}>
              <Box sx={searchBarContainer}>
                <SearchBar value={queryStok} setSearchTerm={setQueryStok} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Satuan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Sisa
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stoks.map((stok, index) => (
                    <TableRow
                      key={stok._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setPilihStok(stok.kodeStok);
                        setKodeStok(stok.kodeStok);
                        setNamaStok(stok.namaStok);
                        setQuantityLama("0");
                        setQuantity("0");
                        setHargaSatuan("0");
                        setDiscountPersen1("0");
                        setDiscount1("0");
                        setHargaNetto("0");
                        setTotalReturPembelianChild("0");

                        handleCloseStok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {stok.kodeStok}
                      </TableCell>
                      <TableCell>{stok.namaStok}</TableCell>
                      <TableCell>{stok.satuanKecilStok}</TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesStok}
                page={pageStok + 1}
                onChange={handleChangeStok}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={handleCloseUbah}
        aria-labelledby="customized-dialog-title"
        open={openUbah}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Ubah Barang ReturPembelian
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseUbah}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          dividers
          //  sx={{ height: "200px" }}
        >
          <div>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Kode / Barcode :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={pilihStok} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Nama Stok :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={namaStok} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Quantity <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={quantity}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        const tempValue = values.value;
                        setQuantity(tempValue);

                        let tempHargaNetto =
                          parseFloat(hargaSatuan) - parseFloat(discount1);
                        setHargaNetto(tempHargaNetto);

                        let tempTotalReturPembelianChild =
                          parseFloat(tempValue) * parseFloat(tempHargaNetto);
                        setTotalReturPembelianChild(
                          tempTotalReturPembelianChild,
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Harga Satuan <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={hargaSatuan}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        let tempValue = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setHargaSatuan(tempValue);

                        let tempHargaNetto =
                          parseFloat(tempValue) - parseFloat(discount1);
                        setHargaNetto(tempHargaNetto);

                        let tempTotalReturPembelianChild =
                          parseFloat(quantity) * parseFloat(tempHargaNetto);
                        setTotalReturPembelianChild(
                          tempTotalReturPembelianChild,
                        );

                        let tempDiscount1 =
                          (parseFloat(tempValue) * discountPersen1) / 100;
                        setDiscount1(tempDiscount1);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Disc / Pot. 1 <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="3">
                    <NumericFormat
                      required
                      value={discountPersen1}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values, sourceInfo) => {
                        if (sourceInfo.source !== "event") return;

                        let tempValue = values.formattedValue;
                        setDiscountPersen1(tempValue);

                        let tempDiscount1 =
                          (parseFloat(hargaSatuan) * tempValue) / 100;
                        setDiscount1(tempDiscount1);

                        let temHargaNetto =
                          parseFloat(hargaSatuan) - parseFloat(tempDiscount1);
                        setHargaNetto(temHargaNetto);

                        let tempTotalReturPembelianChild =
                          parseFloat(quantity) * parseFloat(temHargaNetto);
                        setTotalReturPembelianChild(
                          tempTotalReturPembelianChild,
                        );
                      }}
                    />
                  </Col>
                  <Col sm="4">
                    <NumericFormat
                      required
                      value={discount1}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values, sourceInfo) => {
                        if (sourceInfo.source !== "event") return;
                        let tempValue = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                        setDiscount1(tempValue);

                        let tempDiscountPersen1 =
                          (parseFloat(tempValue) / parseFloat(hargaSatuan)) *
                          100;
                        // limit to 2 decimals
                        tempDiscountPersen1 = Number(
                          tempDiscountPersen1.toFixed(2),
                        );
                        setDiscountPersen1(tempDiscountPersen1);

                        let temHargaNetto =
                          parseFloat(hargaSatuan) - parseFloat(tempValue);
                        setHargaNetto(temHargaNetto);

                        let tempTotalReturPembelianChild =
                          parseFloat(quantity) * parseFloat(temHargaNetto);
                        setTotalReturPembelianChild(
                          tempTotalReturPembelianChild,
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Harga Netto :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      disabled
                      value={hargaNetto}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Total :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      disabled
                      value={totalReturPembelianChild}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={updateReturPembelianChild}
          >
            Simpan
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default UbahReturPembelian;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const tableChildWrapper = {
  mt: 4,
  height: "400px",
  overflowY: "auto",
  border: "1px solid #e0e0e0",
};
